import React from "react";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { Dimensions } from "react-native";

const { width } = Dimensions.get("window");

export const BUBBLE_WIDTH = isWebDesktop ? 250 : width / 2;
